import React from 'react';
import { CenteredMessage } from './CenteredMessage';
import { Download } from 'lucide-react';

function LeadInfoComponent({ leadInfo }) {
    const hasData = Object.keys(leadInfo).length > 0;

    const formatKey = (key) =>
        key.replace(/([A-Z])/g, ' $1')
            .replace(/_/g, ' ')
            .replace(/^./, str => str.toUpperCase());

    const formatValue = (value) => {
        if (value === null || value === undefined || value === '') return '–';
        return String(value);
    };

    const exportToCSV = () => {
        const headers = ['Field', 'Value'];
        const rows = Object.entries(leadInfo).map(([key, value]) => [
            formatKey(key),
            formatValue(value)
        ]);

        const csvContent = [headers, ...rows]
            .map((row) =>
                row
                    .map((cell) => `"${cell.replace(/"/g, '""')}"`) // escape quotes
                    .join(',')
            )
            .join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'lead_info.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',

            padding: '20px'
        }}>
            {!hasData ? (
                <CenteredMessage text="No lead info available." />
            ) : (
                <>

                    <table style={{
                        width: '100%',
                        maxWidth: '700px',
                        borderCollapse: 'separate',
                        borderSpacing: '0',
                        fontSize: '15px',
                        color: '#1f2937',
                        backgroundColor: '#ffffff',
                        border: '1px solid #e5e7eb',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
                    }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f3f4f6' }}>
                                <th style={{
                                    textAlign: 'left',
                                    padding: '12px 16px',
                                    fontWeight: 600,
                                    borderBottom: '1px solid #e5e7eb'
                                }}>Field</th>
                                <th style={{
                                    textAlign: 'left',
                                    padding: '12px 16px',
                                    fontWeight: 600,
                                    borderBottom: '1px solid #e5e7eb'
                                }}>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(leadInfo).map(([key, value], index) => (
                                <tr
                                    key={key}
                                    style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9fafb' }}
                                >
                                    <td style={{
                                        padding: '12px 16px',
                                        fontWeight: 500,
                                        borderBottom: '1px solid #e5e7eb',
                                        whiteSpace: 'nowrap'
                                    }}>
                                        {formatKey(key)}
                                    </td>
                                    <td style={{
                                        padding: '12px 16px',
                                        borderBottom: '1px solid #e5e7eb',
                                        wordBreak: 'break-word'
                                    }}>
                                        {formatValue(value)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button
                        onClick={exportToCSV}
                        style={{
                            alignSelf: 'flex-start',
                            marginBottom: '10px',
                            marginTop: '20px',
                            padding: '8px 16px',
                            backgroundColor: '#10b981',
                            color: 'white',
                            fontWeight: 600,
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                        }}
                    >
                        <Download size={16} />
                        Export to CSV
                    </button>
                </>
            )}
        </div>
    );
}

export default LeadInfoComponent;
